const BANNER_SESSION_KEY = 'notification_banner_dismissed';

const dismissNotificationBanner = (banner: HTMLElement): void => {
  banner.classList.add('notification-banner--hidden');
  sessionStorage.setItem(BANNER_SESSION_KEY, 'true');
}


export const initNotificationBanner = (): void => {
  const banner = document.querySelector<HTMLElement>('.notification-banner');
  const closeButton = banner?.querySelector<HTMLButtonElement>('.notification-banner__close');
 
  if (!banner || !closeButton) return;
 
  const isDismissed = sessionStorage.getItem(BANNER_SESSION_KEY) === 'true';
 
  if (isDismissed) {
    banner.classList.add('notification-banner--hidden');
    return;
  }
 
  closeButton.addEventListener('click', () => {
    dismissNotificationBanner(banner);
  });
}
